'use client';

import { useActiveBrand } from '@/_hooks/useActiveBrand';
import { IRedux } from '@/_store/types';
import { Link, usePathname } from '@/i18n/navigation';
import { useNavigationState } from '@/shared/store/use-navigation-state';
import { Button } from '@/shared/ui/button';
import { Circle, HStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useSelector } from 'react-redux';

export default function Bottom() {
  const t = useTranslations();
  const pathname = usePathname();
  const { setRedirectTo } = useNavigationState();

  const cartState = useSelector((state: IRedux) => state.cart.cart);
  const shipperId = useActiveBrand()
  const cart = cartState?.[shipperId]?.products || []

  const hash = typeof window !== 'undefined' ? window.location.hash : null;
  const fullUrl = hash ? `${pathname}?${hash.toString()}` : pathname;

  if (cart?.length > 0)
    return (
      <HStack
        position="fixed"
        bottom="0"
        left="0"
        w="full"
        roundedTop="15px"
        bgColor="background.card"
        height="70px"
        boxShadow="0px -8px 30px 0px #00000014"
        px={4}
        zIndex={20}
      >
        <Button
          flex={1}
          size="xl"
          bg="primary"
          color="primary.text"
          _hover={{
            bg: 'primary.hover',
          }}
          asChild
        >
          <Link
            href="/cart"
            scroll={false}
            onClick={() => setRedirectTo(fullUrl)}
          >
            {t('go_to_cart')}
            <Circle size="4" bg="white" fontSize="9px" color="primary">
              {cart.length}
            </Circle>
          </Link>
        </Button>
      </HStack>
    );

  return null;
}
